// extracted by mini-css-extract-plugin
export var backdropBlur = "_cq-0";
export var contentCard = "_cq-5";
export var frame = "_cq-2";
export var image = "_cq-4";
export var imagePane = "_cq-3";
export var modal = "_cq-1";